<template lang="pug">
.m39-property-interest
	.m39-property-interest__questions(v-if="!response")
		h3.m39-property-interest__title {{$t('AADAT.interested')}}
		form.m39-property-interest__form(name="interestForm", @submit.prevent="send")
			.m39-property-interest__row
				.m39-property-interest__cell
					VueRadioGroup(
						id="interest-select",
						legend="Értékesítés típusa",
						v-model="model.interest",
						:is-legend-hidden="true"
						:options="interestValues",
					)
					VueButton(type="submit" :disabled="$v.$invalid") {{$t('AADAT.intrestedSend')}}
	.m39-property-interest__response(v-if="response")
		h5.m39-property-interest__success(v-if="response == 'success'") {{$t('AADAT.intrestedSendSuccess')}}
		h5.m39-property-interest__fail(v-if="response == 'error'") {{$t('AADAT.intrestedSendFail')}}
</template>
<script>
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueButton from '@ui-common/vue-button';
import { required } from 'vuelidate/lib/validators';
import propertyInterestApi from '../../api/property-interest-api';
export default {
	data: () => ({
		model: {
			interest: null
		},
		interestValues: null,
		response: null
	}),
	props: {
		kNumber: {
			type: String,
			required: true
		},
		comissionId: {
			type: String,
			required: true
		}
	},
	validations() {
		return {
			model: {
				interest: {
					required
				}
			}
		};
	},
	components: {
		VueRadioGroup,
		VueButton
	},
	methods: {
		async send() {
			const params = {
				comissionId: this.comissionId,
				interest: this.model.interest,
				interestId: this.kNumber
			};

			try {
				await propertyInterestApi.sendInterest(params);
				this.response = 'success';
			} catch (err) {
				this.response = 'error';
			}
		}
	},
	created() {
		this.interestValues = [
			{ key: 'interested', value: this.$t('AADAT.interestedYes') },
			{ key: 'notInterested', value: this.$t('AADAT.interestedNo') },
			{ key: 'lowerPrice', value: this.$t('AADAT.interestedLowerPrice') }
		];
	}
};
</script>
<style src="@ui-common/vue-radio-group/dist/vue-radio-group.css"></style>